import { render, staticRenderFns } from "./labelPropertyManage.vue?vue&type=template&id=05ea6cd2"
import script from "./labelPropertyManage.vue?vue&type=script&lang=js"
export * from "./labelPropertyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ea6cd2')) {
      api.createRecord('05ea6cd2', component.options)
    } else {
      api.reload('05ea6cd2', component.options)
    }
    module.hot.accept("./labelPropertyManage.vue?vue&type=template&id=05ea6cd2", function () {
      api.rerender('05ea6cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/labelManage/labelPropertyManage.vue"
export default component.exports